export const GET_VEHICLE_RECOMMENDATION = "GET_VEHICLE_RECOMMENDATION";
export const GET_VEHICLE_RECOMMENDATION_SUCCESS =
  "GET_VEHICLE_RECOMMENDATION_SUCCESS";
export const GET_VEHICLE_RECOMMENDATION_FAILURE =
  "GET_VEHICLE_RECOMMENDATION_FAILURE";

export const GET_VEHICLE_RECOMMENDATION_BYTOKEN =
  "GET_VEHICLE_RECOMMENDATION_BYTOKEN";
export const GET_VEHICLE_RECOMMENDATION_BYTOKEN_SUCCESS =
  "GET_VEHICLE_RECOMMENDATION_BYTOKEN_SUCCESS";
export const GET_VEHICLE_RECOMMENDATION_BYTOKEN_FAILURE =
  "GET_VEHICLE_RECOMMENDATION_BYTOKEN_FAILURE";

export const RESET_VEHICLE_RECOMMENDATION = "RESET_VEHICLE_RECOMMENDATION";

export interface VehicleRecommendationState {
  vehicleRecommendationList: any;
  vehicleRecommendationSuccess: string | null;
  vehicleRecommendationError: string | null;
  vehicleRecommendationLoading: boolean;
  vehicleRecommendationData: any;
}

interface GetVehicleRecommendation {
  type: typeof GET_VEHICLE_RECOMMENDATION;
  payload: any;
}

interface GetVehicleRecommendationSuccess {
  type: typeof GET_VEHICLE_RECOMMENDATION_SUCCESS;
  payload: any;
}

interface GetVehicleRecommendationFailure {
  type: typeof GET_VEHICLE_RECOMMENDATION_FAILURE;
  payload: string;
}

interface GetVehicleRecommendationByToken {
  type: typeof GET_VEHICLE_RECOMMENDATION_BYTOKEN;
  payload: any;
}

interface GetVehicleRecommendationByTokenSuccess {
  type: typeof GET_VEHICLE_RECOMMENDATION_BYTOKEN_SUCCESS;
  payload: any;
}

interface GetVehicleRecommendationByTokenFailure {
  type: typeof GET_VEHICLE_RECOMMENDATION_BYTOKEN_FAILURE;
  payload: string;
}

interface ResetFaqAction {
  type: typeof RESET_VEHICLE_RECOMMENDATION;
}

export type VehicleRecommendationTypes =
  | GetVehicleRecommendationByToken
  | GetVehicleRecommendationByTokenSuccess
  | GetVehicleRecommendationByTokenFailure
  | GetVehicleRecommendation
  | GetVehicleRecommendationSuccess
  | GetVehicleRecommendationFailure
  | ResetFaqAction;
